import * as React from 'react';
import { EditComponent, CustomComponentProps, CreateComponent } from 'src/components/common/Component';

export function SampleSubscriberEditComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <EditComponent attributes={["email"]} children={children} />
    );
}

export function SampleSubscriberCreateComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <CreateComponent source={"Sample Subscriber"} children={children} />
    );
}